import { render, staticRenderFns } from "./classeSg.vue?vue&type=template&id=6974c15f&"
import script from "./classeSg.vue?vue&type=script&lang=js&"
export * from "./classeSg.vue?vue&type=script&lang=js&"
import style0 from "./classeSg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports